export default __webpack_public_path__ + "static/2-descendant-3d02522981b6a2a9e2c0e059af09cc8f.png";